document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('how-it-works-news')) {
    class HowItWorksNews extends HTMLElement {
      constructor() {
        super();

        this.containerSteps = this.querySelector('.container-steps');

        window.addEventListener('resize', () => {
          this.onResize();
        });

        this.onResize();
      }

      onResize() {
        if (window.innerWidth < 870) {
          this.enableSwiper();
        } else {
          if (this.slider) this.slider.destroy(true, true);
        }
      }

      enableSwiper() {
        this.slider = new Swiper(this.containerSteps, {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });

        this.slider.on('slideChange', () => {
          if (this.slider.realIndex > 0) {
            this.classList.remove('active');
          } else {
            this.classList.add('active');
          }
        });
      }
    }

    customElements.define('how-it-works-news', HowItWorksNews);
  }
});
